<template>
    <div class="row-pointer">
        <v-row :dense="isDense">
            <v-col :cols="col1">Claimed amount</v-col>
            <v-col :cols="col1">€ {{this.amount | nl_numberformat}}
                <span v-if="!this.componentsVisible">
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small v-bind="attrs" v-on="on" v-on:click="showHideComponents()">
                                <v-icon>mdi-chevron-down</v-icon></v-btn>
                        </template>
                        <span>Show more</span>
                    </v-tooltip>
                </span>
                <span v-else>
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon x-small  v-bind="attrs" v-on="on" v-on:click="showHideComponents()">
                                <v-icon>mdi-chevron-up</v-icon></v-btn>
                        </template>
                        <span>Show less</span>
                    </v-tooltip>
                </span>
            </v-col>                        
        </v-row>
        <div v-if="this.componentsVisible">            
            <v-card flat class="mt-3">
                <div v-if="this.components.length > 0">
                    <v-data-table :headers="getComponentHeaders()"                         
                                  :items="components" 
                                  :disable-pagination=true                                  
                                  item-key="key" 
                                  dense 
                                  hide-default-footer>  
                        <template v-slot:item.currency>
                            <td style="text-align: end;">€</td>
                        </template>    
                        <template slot="body.append" dense>
                            <tr style="text-align: end;">
                                <td>Claimed amount</td>
                                <td>€</td>
                                <td><b>{{ this.amount | nl_numberformat }}</b></td>                                                        
                            </tr>
                        </template>                                                      
                    </v-data-table>                        
                </div>   
            </v-card>
        </div>
    </div>    
</template>

<script>

import mxnumberformat from '@/mixins/amount_nl';

export default {
    props: {
        amount: {
            type: String,
            default: '0,00'
        },
        components: {
            type: Array,
            default: function() { return []; },
        },
        col1:{
            type: Number,
            default: 2
        }, 
        col2:{
            type: Number,
            default: 4
        }, 
        isDense:{
            type: Boolean,
            default: false
        }
    },
    components: {
    }, 
    mixins: [mxnumberformat],
    data() {
        return {
            componentsVisible: false,
        }
    }, 
    methods: {
        showHideComponents(){
           this.componentsVisible = !this.componentsVisible;
        },   
        getComponentHeaders() {
            return [
                { text: "Components", value: "description", sortable: false },
                { text: "", value: "currency", width: "1%", sortable: false },
                { text: "", value: "amount", width: "10%", align: "end", sortable: false },
            ];
        },              
    }
}
</script>

<style scoped>
    .row-pointer {
        cursor: default;
    }
</style>